import type { ToolActivity } from "../tool-activity";
import { toolInput } from "../tool-input";
import type { ToolActivityState } from "../tool-activity-state";
import { captureLabel } from "./capture-label";
import { captureTarget } from "./capture-target";
import { CAPTURE_LABEL_MAX } from "./capture-label-constants";

export function describeTakeScreenshot(
  record: Record<string, unknown>,
  state: ToolActivityState,
): ToolActivity {
  const target = captureTarget(toolInput.str(record.url));
  return captureLabel(
    {
      optionFailed: "Failed to take a silent screenshot",
      optionRunning: "Taking a silent screenshot",
      optionDone: "Took a silent screenshot",
      failed: (subject) =>
        subject
          ? `Failed to screenshot ${subject}`
          : "Failed to take a screenshot",
      running: (subject) =>
        subject ? `Taking a screenshot of ${subject}` : "Taking a screenshot",
      done: (subject) =>
        subject ? `Took a screenshot of ${subject}` : "Took a screenshot",
    },
    state,
    {
      isOption: record.silent === true,
      subject: target ? toolInput.truncate(target, CAPTURE_LABEL_MAX) : null,
    },
  );
}
